export enum LocalStorageKey {
  LAST_ACTIVE = '_lastActive'
}
